module.exports = __webpack_public_path__ + "img/trekkspace.b45c7573.png";